import { CheckboxField, InputField } from 'components/inputs';
import { Form, Formik, FormikHelpers, FormikProps } from 'formik';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { IGenericPayload } from 'services/types.d';

import { GenericFormValidationSchema } from './helpers';

export interface IGenericFormProps {
  /**
   * Form initial values, can be a complete or partial IGenericPayload
   * object which will allow to support create and update requests.
   */
  initialValues: IGenericPayload;
  /**
   * On submit action, for this form this will be controlled from the outside
   * of this component thanks to the forward ref property.
   */
  onSubmit: (v: IGenericPayload, h?: FormikHelpers<IGenericPayload>) => void;
}

export const GenericForm = forwardRef<
  FormikProps<IGenericPayload>,
  IGenericFormProps
>((props, ref) => {
  const { initialValues, onSubmit } = props;
  const { t } = useTranslation('common');

  return (
    <Formik
      initialValues={{ ...initialValues }}
      innerRef={ref}
      onSubmit={onSubmit}
      validationSchema={GenericFormValidationSchema}
    >
      <Form>
        <InputField label={t('inputs.name.label')} mb={4} name="name" />
        <CheckboxField label={t('inputs.is-active.label')} name="is_active" />
      </Form>
    </Formik>
  );
});

GenericForm.displayName = 'GenericForm';
